import { useEffect, useState } from "react";
import { Employer } from "@services/all.services";
import { checkEnterpriseId } from "@helpers/_functions";
import { useNotification } from "@hooks/useNotification";

export default function useEmployeeCreationAccess({ show, setValue, getFieldState }) {
  const [options, setOptions] = useState({ permissions: [], accessProfiles: [] });
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useNotification();
  useEffect(() => {
    if (!show) return;
    let active = true;
    setIsLoading(true);
    Employer.getCreationAccessOptions(checkEnterpriseId()).then((response) => {
      if (!active) return;
      if (!Array.isArray(response?.permissions) || !Array.isArray(response?.accessProfiles)) throw new Error("Invalid access options");
      setOptions(response);
      const permission = response.permissions.find((item) => item.isDefault);
      const profile = response.accessProfiles.find((item) => item.isDefault);
      if (permission && !getFieldState("permission").isDirty) setValue("permission", permission);
      if (profile && !getFieldState("accessProfile").isDirty) setValue("accessProfile", profile);
    }).catch(() => {
      if (active) showError("error");
    }).finally(() => {
      if (active) setIsLoading(false);
    });
    return () => { active = false; };
  }, [show, setValue, getFieldState, showError]);
  return { ...options, isLoading };
}
